/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Cleared_ToastInputs */

const en_us2_plan_build_cleared_toast = /** @type {(inputs: Plan_Build_Cleared_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan cleared. Start with Workout A.`)
};

const pt_br2_plan_build_cleared_toast = /** @type {(inputs: Plan_Build_Cleared_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano zerado. Comece pelo Treino A.`)
};

const es_419_plan_build_cleared_toast = /** @type {(inputs: Plan_Build_Cleared_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan vacío. Empieza con el Entrenamiento A.`)
};

const pt_pt2_plan_build_cleared_toast = /** @type {(inputs: Plan_Build_Cleared_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano apagado. Começa pelo Treino A.`)
};

const fr_fr2_plan_build_cleared_toast = /** @type {(inputs: Plan_Build_Cleared_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programme vidé. Commence par la séance A.`)
};

const de_de2_plan_build_cleared_toast = /** @type {(inputs: Plan_Build_Cleared_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan geleert. Fang mit Training A an.`)
};

const it_it2_plan_build_cleared_toast = /** @type {(inputs: Plan_Build_Cleared_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheda svuotata. Inizia dall'Allenamento A.`)
};

/**
* | output |
* | --- |
* | "Plan cleared. Start with Workout A." |
*
* @param {Plan_Build_Cleared_ToastInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_cleared_toast = /** @type {((inputs?: Plan_Build_Cleared_ToastInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Cleared_ToastInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_cleared_toast(inputs)
	if (locale === "es-419") return es_419_plan_build_cleared_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_cleared_toast(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_cleared_toast(inputs)
	if (locale === "de-DE") return de_de2_plan_build_cleared_toast(inputs)
	if (locale === "it-IT") return it_it2_plan_build_cleared_toast(inputs)
	return en_us2_plan_build_cleared_toast(inputs)
});
export { plan_build_cleared_toast as "plan-build.cleared_toast" }